import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import EnumQuestion from "@/lib/enum/question";
import _ from "lodash-es";

export class Answer extends Model {
  content = "";
  isRight = false;
  key = "";
  keyScore = 0;
}

export class PlayInfo extends Model {
  playUrl = "";
  size = 0;
}
export class AsrItem extends Model {
  bg = 0;
  ed = 0;
  txt = "";
}
export class PlayInfoList extends Model {
  playInfo: PlayInfo[] = [new PlayInfo()];
}
export class AiVideoInfo extends Model {
  playInfoList = new PlayInfoList();
  requestId = "";
}

export class ResultJson extends Model {
  images: string[] = [""];
}

export class QuestionCandidateAnswer extends Model {
  score = 0;
  scoreAi = 0;
  aiProcessStatus = 0;
  scoreStatus = 0;
  isAnswered = 0;
  keyList: string[] = [""];
  contentList: string[] = [""];
  subScoreList: number[] = [0];
  resultJsonList: ResultJson[] = [new ResultJson()];
  imagesList: string[][] = [[""]];
  aiVideoInfo = new AiVideoInfo();
  asrStatus = 0; //asr转义状态
  asrList: AsrItem[] = [new AsrItem()]; //asr结果
}

export class BlankQuestionAnswer extends Model {
  score = 0; // 每空单独计分分支下的每空分数 所有空分数总和必须为100
  words = ""; //答案 多个答案用||| 分割 禁止空
}

export class BlankQuestionConfig extends Model {
  strictOrder = 0;
  answerList: BlankQuestionAnswer[] = [new BlankQuestionAnswer()];
}
export class WorkLocation extends Model {
  locationLat = "";
  locationLng = "";
  locationName = "";
}
export class TimeToScoreRule extends Model {
  score = 0; //分值
  timeRange: number[] = [0]; //时间区间(分)
}
export class ChoiceQuestion extends Model {
  desc = "";
  key = "";
  score = 0;
}
export class LocationQuestionConfig extends Model {
  workLocationList: WorkLocation[] = [new WorkLocation()]; //上班地点
  useDrivingTime = 0; // 是否使用驾车时间 否则采用公交时间 1驾车
  timeToScoreRules: TimeToScoreRule[] = [new TimeToScoreRule()]; //参考答案 通勤时间与分值
  choiceQuestionList: ChoiceQuestion[] = [new ChoiceQuestion()]; //单选答案 看待时间态度
}
export class QuestionInfo extends Model {
  score = 0;
  type = 0;
  isObjective = false;
  desc = "";
  locationQuestionConfig = new LocationQuestionConfig(); //通勤-时间-坐标
  blankQuestionConfig = new BlankQuestionConfig();
  videoQuestionConfig: any = "";
  getTypeName(): string {
    const name = _.get(EnumQuestion.typeListData, this.type);
    return _.isEmpty(name) ? "未知题型" : name;
  }
  //单选题
  isTypeSelection(): boolean {
    return this.type === 1;
  }
  //多选题
  isTypeMultiSelection(): boolean {
    return this.type === 2;
  }
  //判断题
  isTypeSelection2(): boolean {
    return this.type === 3;
  }
  //问答题
  isTypeEssay(): boolean {
    return this.type === 4;
  }
  //填空题
  isTypeFill(): boolean {
    return this.type === 5;
  }
  //视频题
  isTypeVideo(): boolean {
    return this.type === 6;
  }
  //评测题
  isTypeEvaluating(): boolean {
    return this.type === 7;
  }
  //通勤时间题
  isTypeLocation(): boolean {
    return this.type === 101;
  }
}

export class CandidateInfo extends Model {
  candidateId = "";
  connectCode = "";
  email = "";
  phone = "";
  showName = "";
  cityName = "";
  subjectName = "";
  trainingTime = "";
  submitStatus = 0;
  scoreAll = 0;
  auditStatus = 0;
  auditDesc = "";

  isAudited(): boolean {
    return this.auditStatus > 0;
  }
}

export class Question extends Model {
  questionId = "";
  answerList: Answer[] = [new Answer()];
  candidateAnswer = new QuestionCandidateAnswer();
  questionInfo = new QuestionInfo();

  isRight(): boolean {
    return this.candidateAnswer.score > 0;
  }
  isSubRight(idx: number): boolean {
    return this.candidateAnswer.subScoreList[idx] > 0;
  }
  isManualMarked(): boolean {
    return this.candidateAnswer.scoreStatus !== 0;
  }
  isAiMarked(): boolean {
    return this.candidateAnswer.aiProcessStatus === 3;
  }
}

export class Count extends Model {
  all = 0;
  hasAudited = 0;
  hasSubmit = 0;
}
export class CompanySpecialConfig extends Model {
  auditDescMust = 0; // 是否评价详情必填
  auditRepeat = 0; // 是否允许重复阅卷
  auditUndetermined = 0; // 是否允许阅卷待定
  changeUi = 0; // 是否使用小程序新版UI
  livenessRecognition = 0; // 是否开放活体检测功能
  preferWxmini = 0; // 是否在面试列表页倾向展示微信小程序而非H5链接
  useWxUrl = 0; // 是否使用跳转微信小程序的H5链接 aic/examc
  enableAibuilderExam = 0; //是否有aibuilder通用版权限
  enableWorkerExam = 0; //是否有普工版权限
  openIvh = 0; //是否开启ivh 虚拟视频
  vipLevel = 0; //付费类型 0免费 10付费版
  enableMessageNotice = 0; //是否开放面试提醒
  version = ""; //公司级面试版本 '' 或 '0331'
  enableReportCertiCode = 0; //公司是否有权开启报告提取码功能
}

export class ExamInfo extends Model {
  examId = "";
  name = "";
  companyId = "";
  scoreAll = 0;
  scoreObjectiveAll = 0;
  isCheckMobile = 0;
  companySpecialConfig = new CompanySpecialConfig();
}

export default class CandidateAnswer extends Model {
  candidateInfo = new CandidateInfo();
  count = new Count();
  examInfo = new ExamInfo();
  questions: Question[] = [new Question()];

  static get(connectCode: string, reviewer = "") {
    return request
      .post("onlineExam/audit/candidateAnswer", {
        connectCode: connectCode,
        reviewer: reviewer
      })
      .then(resp => {
        return new CandidateAnswer(resp).assign(resp.data.data);
      });
  }
}
